/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon24Solid = forwardRef('TextBulletIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.5 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M9 4.5A1.5 1.5 0 0 1 10.5 3h10a1.5 1.5 0 0 1 0 3h-10A1.5 1.5 0 0 1 9 4.5Z" }),
        React.createElement("path", { d: "M10.5 10a1.5 1.5 0 0 0 0 3h10a1.5 1.5 0 1 0 0-3h-10Z" }),
        React.createElement("path", { d: "M10.5 17a1.5 1.5 0 0 0 0 3h10a1.5 1.5 0 1 0 0-3h-10Z" }),
        React.createElement("path", { d: "M6.5 11.5a2 2 0 1 1-3.999 0 2 2 0 0 1 3.999 0Z" }),
        React.createElement("path", { d: "M4.5 20.498a1.998 1.998 0 1 0 0-3.996 1.998 1.998 0 0 0 0 3.996Z" })));
});
